/**
 * What an optimizer pop-up edits, beside its title: the container (or master
 * config) chip, its kind, and — for a group's list formula — the group.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';

import { ContainerChip } from '../../shared/ContainerChip';
import type { ContainerEditor } from '../state/useContainerEditor';

export const DialogSubject: FC<{ editor: ContainerEditor; extra?: ReactNode }> = ({ editor, extra }) => (
  <span className="flex items-center gap-2">
    <ContainerChip name={editor.draft.name || 'New container'} color={editor.draft.color} routeTest={editor.draft.kind === 'ROUTE_TEST'} />
    <span className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground/70">{editor.draft.kind === 'MASTER' ? 'master config' : 'container'}</span>
    {extra}
  </span>
);
